const DEFAULT_CANONICAL_WEB_ORIGIN = 'https://sacmetrolinemedic.app';

function normalizeHttpOrigin(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  try {
    const parsed = new URL(raw);
    if (!['http:', 'https:'].includes(parsed.protocol)) return '';
    return `${parsed.protocol}//${parsed.host}`;
  } catch (_) {
    return '';
  }
}

export function canonicalWebOrigin() {
  return normalizeHttpOrigin(process.env.REACT_APP_CANONICAL_WEB_ORIGIN)
    || DEFAULT_CANONICAL_WEB_ORIGIN;
}

export function isNativeShell() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.Capacitor?.isNativePlatform?.()) return true;
  } catch (_) {}
  return !['http:', 'https:'].includes(String(window.location?.protocol || '').toLowerCase());
}

export function authRedirectUrl(path = '/') {
  const canonical = canonicalWebOrigin();
  if (typeof window === 'undefined' || isNativeShell()) {
    return new URL(path, `${canonical}/`).toString();
  }
  const webOrigin = normalizeHttpOrigin(window.location?.origin) || canonical;
  return new URL(path, `${webOrigin}/`).toString();
}
